// @flow
import React from "react";
import type { IconProps } from "./";

type Props = {
  ...IconProps,
  className?: string,
  onClick?: () => void
};

export default function Bell({
  width = "20px",
  fill = "currentColor",
  ...props
}: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 19"
      fill={fill}
      width={width}
      {...props}
    >
      <g transform="translate(0 0)">
        <path
          d="M88.121,56.771V55.2a5.413,5.413,0,0,0-4.293-5.18v-1.6a1.379,1.379,0,0,0-2.752,0v1.6a5.413,5.413,0,0,0-4.293,5.18v1.573a6.158,6.158,0,0,1-1.972,4.483,1.75,1.75,0,0,0-.421,1.991,1.945,1.945,0,0,0,1.793,1.128H79.6a2.853,2.853,0,0,0,5.7,0h3.421a1.945,1.945,0,0,0,1.793-1.128,1.75,1.75,0,0,0-.421-1.991A6.158,6.158,0,0,1,88.121,56.771ZM82.451,65.5a1.165,1.165,0,0,1-1.2-1.127h2.394A1.165,1.165,0,0,1,82.451,65.5Zm6.536-2.85a.289.289,0,0,1-.267.168H76.182a.289.289,0,0,1-.267-.168.26.26,0,0,1,.063-.3,7.619,7.619,0,0,0,2.455-5.583V55.2a4.025,4.025,0,0,1,8.036,0v1.573a7.619,7.619,0,0,0,2.455,5.583A.26.26,0,0,1,88.988,62.65Z"
          transform="translate(-72.451 -47.056)"
          fill={fill}
        />
        <path
          d="M61.853,75.255a.777.777,0,0,0,.485-.987,4.834,4.834,0,0,1,3.014-6.127.778.778,0,0,0-.5-1.472,6.39,6.39,0,0,0-3.984,8.1.777.777,0,0,0,.987.485Z"
          transform="translate(-60.524 -66.628)"
          fill={fill}
        />
        <path
          d="M283.994,66.67a.778.778,0,0,0-.5,1.472,4.834,4.834,0,0,1,3.014,6.127.778.778,0,1,0,1.472.5A6.39,6.39,0,0,0,283.994,66.67Z"
          transform="translate(-268.32 -66.628)"
          fill={fill}
        />
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/Icons/Bell.js